import { ArrowRight } from "lucide-react";
import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { restoreAuthFromStorage } from '../api/Client';
import '../styles/home.css';

export default function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const { access, refresh, user } = await restoreAuthFromStorage();
      console.log("🔑 Restaurado:", { access, refresh, user });
      if (access) {
        navigate('/product', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <>
      <div className="entry-page">
        <div className="entry-top-band" aria-hidden="true" />
        <div className="entry-glow" aria-hidden="true" />
        <div className="entry-mesh" aria-hidden="true" />

        <div className="entry-layout">
          <div className="entry-card">
            <div className="entry-brand">
              <div className="entry-logo">F</div>
              <div className="entry-brand-copy">
                <span className="entry-brand-name">Fidelis</span>
                <span className="entry-brand-tagline">Tu espacio para entrenar, reservar y seguir avanzando.</span>
              </div>
            </div>

            <div className="entry-copy">
              <span className="entry-kicker">App cliente</span>
              <h1>Accede a tu centro</h1>
              <p>Consulta tus productos, compra nuevos servicios y gestiona tus reservas desde un mismo lugar.</p>
            </div>

            <div className="entry-actions">
              <Link to="/login" className="entry-primary-btn">
                <span>Iniciar sesion</span>
                <ArrowRight size={16} />
              </Link>

              <Link to="/public-services" className="entry-secondary-link">
                Ver servicios y productos disponibles
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
